import React from "react";
import PropTypes from "prop-types";
import Button from "components/Button";

const PayButton = ({
  termsAccepted,
  handleSubmit,
  isProcessing,
  price,
  paymentMethod,
  cartItems,
}) => {
  return (
    <Button
      block
      rounded
      color="green"
      label={`Pay ${parseFloat(price).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      })}`}
      loading={isProcessing}
      disabled={
        !termsAccepted ||
        paymentMethod === null ||
        isProcessing ||
        !cartItems?.length
      }
      onClick={handleSubmit}
    />
  );
};

PayButton.defaultProps = {
  termsAccepted: false,
  handleSubmit: () => {},
  isProcessing: false,
  price: "",
  paymentMethod: "",
  cartItems: {},
};

PayButton.propTypes = {
  termsAccepted: PropTypes.bool,
  handleSubmit: PropTypes.func,
  isProcessing: PropTypes.bool,
  price: PropTypes.string,
  paymentMethod: PropTypes.string,
  cartItems: PropTypes.object,
};
export default PayButton;
